import React from "react";
import GroupCockpitProfile from "../pages/groupCockpit/GroupCockpitProfile";
import ChangePassword from "../pages/groupCockpit/ChangePassword";
import Syllabus from "../pages/staff/Master/syllabus/Syllabus";
import UserDashboardResolver from "./UserDashboardResolver";
import StaffTimeTable from "../pages/staff/Master/timeTable/StaffTimeTable";
import StudentList from "../pages/schoolCockpit/master/student/StudentList";
import StudentCreate from "../pages/schoolCockpit/master/student/StudentCreate";
import ExamScheduleView from "../pages/schoolCockpit/exam/examSchedule/ExamScheduleView";
import ManageAttendanceCreate from "../pages/staff/attendance/manageAttendance/ManageAttendanceCreate";
import ManageAttendanceList from "../pages/staff/attendance/manageAttendance/ManageAttendanceList";
import MonthlyAttendanceReport from "../pages/staff/attendance/monthlyAttendanceReport/MonthlyAttendanceReport";
import LeaveApproval from "../pages/staff/leave/LeaveApproval";
import LeaveList from "../pages/staff/leave/LeaveList";
import HolidayList from "../pages/schoolCockpit/master/holiday/HolidayList";
import ExamMarkEntry from "../pages/staff/exam/ExamMarkEntry";
import ExamMarkEntryCreate from "../pages/staff/exam/EamaMarkEntryCreate";
import PublishMarkList from "../pages/staff/exam/publishMark/PublishMarkList";
import PublishMarkView from "../pages/staff/exam/publishMark/PublishMarkView";
import CreateMessage from "../pages/groupCockpit/message/Createmessage";
import MessagingEmail from "../pages/groupCockpit/message/MessagingEmail";
import ExamResult from "../pages/schoolCockpit/exam/examResult/ExamResult";
import ViewExamMarkEntry from "../pages/staff/exam/ViewExamMarkEntry";
import CalendarList from "../pages/schoolCockpit/events/CalendarList";
import VerifyMark from "../pages/staff/exam/VerifyMark";
import MarkBulkUpload from "../pages/staff/exam/MarkBulkUpload";
import ViewStaffSyllabus from "../pages/staff/Master/syllabus/ViewStaffSyllabus";
import ViewAnnouncement from "../pages/schoolCockpit/contentManagement/Announcement/ViewAnnouncement";
import ViewAllAnnouncement from "../pages/schoolCockpit/contentManagement/Announcement/ViewAllAnnouncement";
import CreateLessonPlan from "../pages/staff/lessonplan/lessonplancreate/CreateLessonPlan";
import LessonPlanList from "../pages/staff/lessonplan/lessonplanlist/LessonPlanList";
import LessonPlanView from "../pages/staff/lessonplan/lessonplanview/LessonPlanView";
import ScheduleList from "../pages/staff/lessonplan/lessonplanlist/ScheduleList";
import AssessmentTab from "../pages/staff/assessment/AssessmentTab";
import AssessmentCreate from "../pages/staff/assessment/assessment/AssessmentCreate";
import AssessmentView from "../pages/staff/assessment/assessment/AssessmentView";
import ViewAssessmentResult from "../pages/student/book/assessment/ViewAssessmentResult";
import StudyMaterialCreate from "../pages/staff/assessment/studyMaterials/StudyMaterialCreate";
import RemedialCreate from "../pages/staff/assessment/remedialAssessment/RemedialCreate";
import ViewStudyMaterial from "../pages/student/book/BooksMaterial/ViewStudyMaterial";
import RemedialView from "../pages/staff/assessment/remedialAssessment/RemedialView";
import SyllabuSubmissionList from "../pages/staff/Master/syllabusSubmission/syllabuSubmissionList";
import AiDashboard from "../pages/staff/aidashboard/AiDashboard";

export const staffRoutes = [
  // Dashboard
  { path: "dashboard", element: <UserDashboardResolver /> },

  // Profile
  { path: "profile", element: <GroupCockpitProfile /> },
  { path: "change-password", element: <ChangePassword /> },

  // Leave
  { path: "leave", element: <LeaveList /> },
  { path: "leaveApproval", element: <LeaveApproval /> },

  // Attendance
  { path: "attendanceList", element: <ManageAttendanceList /> },
  { path: "attendanceCreate", element: <ManageAttendanceCreate /> },
  { path: "monthlyAttendanceReport", element: <MonthlyAttendanceReport /> },

  // Time Table
  { path: "my-classes/schedule", element: <StaffTimeTable /> },

  // Master
  { path: "student", element: <StudentList /> },
  { path: "studentCreate", element: <StudentCreate /> },
  { path: "holidayList", element: <HolidayList /> },
  { path: "syllabus", element: <Syllabus /> },
  { path: "syllabuSubmissionList", element: <SyllabuSubmissionList /> },
  { path: "viewSyllabus", element: <ViewStaffSyllabus /> },

  // dashBoard
  { path: "ViewAnnouncement", element: <ViewAnnouncement /> },
  { path: "ViewAllAnnouncement", element: <ViewAllAnnouncement /> },

  // Exams
  { path: "examTimeTable", element: <ExamScheduleView /> },
  { path: "exams/marks", element: <ExamMarkEntry /> },
  { path: "exams/markBulkUpload", element: <MarkBulkUpload /> },
  { path: "exams/viewMarks", element: <ViewExamMarkEntry /> },
  { path: "exams/verifyMark", element: <VerifyMark /> },

  { path: "exams/CreateMarks", element: <ExamMarkEntryCreate /> },
  { path: "exams/results", element: <ExamResult /> },
  { path: "publish", element: <PublishMarkList /> },
  { path: "publishView", element: <PublishMarkView /> },

  // Messaging
  {
    path: "messaging/create",
    element: <CreateMessage />,
  },
  { path: "messaging/email", element: <MessagingEmail /> },

  // Events
  { path: "events", element: <CalendarList /> },

  // Lesson Plan
  { path: "lessonplanlist", element: <LessonPlanList /> },
  { path: "lessonplancreate", element: <CreateLessonPlan /> },
  { path: "lessonplanview", element: <LessonPlanView /> },
  { path: "schedulelist", element: <ScheduleList /> },

  // AI Assessment
  { path: "assessmentList", element: <AssessmentTab /> },
  { path: "assessmentCreate", element: <AssessmentCreate /> },
  { path: "assessmentView", element: <AssessmentView /> },
  { path: "viewAssessmentResult", element: <ViewAssessmentResult /> },

  // Remedial
  { path: "remedialCreate", element: <RemedialCreate /> },
  { path: "viewRemedialResult", element: <RemedialView /> },

  //  Study Material
  { path: "studyMaterialCreate", element: <StudyMaterialCreate /> },
  { path: "ViewStudyMaterial", element: <ViewStudyMaterial /> },

  //  AI Dashboard
  { path: "ai-dashboard", element: <AiDashboard /> },
];

export default staffRoutes;
